import React, { FC } from "react";
import { styled } from "@mui/material";
import { Link, LinkProps } from "react-router-dom";

interface SearchCardWraperProps extends LinkProps {
    isAnchor?: boolean;
    onClick?: () => void;
}

export const SearchCardWraper: FC<SearchCardWraperProps> = ({ isAnchor, onClick, children, ...rest }) => {
    if (isAnchor)
        return <Wrap {...rest}>{children}</Wrap>
    return <ButtonWrap onClick={onClick}>{children}</ButtonWrap>
}


const Wrap = styled(Link)`
  display: flex;
  align-items: flex-start;
  max-width:520px;
  width:100%;
  padding: 6px 12px;
  text-decoration: none;
  cursor:pointer;
`;

const ButtonWrap = styled('button')`
  display: flex;
  align-items: flex-start;
  justify-content:flex-start;
  max-width:520px;
  width:100%;
  padding: 6px 12px;
  text-decoration: none;
  cursor:pointer;
  background-color:transparent;
  border:none
`;